<template>
	<v-btn icon variant="text" :title="t('Shopping Cart')" :aria-label="t('Shopping Cart')">
		<v-badge :model-value="cart.count > 0" :content="cart.count" color="secondary">
			<v-icon>shopping_cart</v-icon>
		</v-badge>
		<v-menu v-model="open" activator="parent" :attach="overlayTarget" location="bottom end" offset="8" :close-on-content-click="false" max-height="75vh" width="400">
			<NavCartPanel @close="open = false" />
		</v-menu>
	</v-btn>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import NavCartPanel from './NavCartPanel.vue';
import { legacyNav } from '@/iframe/legacyNavState';
import { useTranslator } from '@/composables/useTranslator';

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);
const open = ref(false);
const cart = computed(() => legacyNav.cart);
</script>
